export default __webpack_public_path__ + "assets/webgl/fire.ff6dbbdb.glb";